<div class="margin-top-bottom">
  <div>
    <mat-label id="example-radio-group-label">{{
      wagonClass.classSelectionTitel
    }}</mat-label>
    <mat-radio-group
      aria-labelledby="example-radio-group-label"
      class="example-radio-group"
      (change)="onSelectionChange($event)"
    >
      <mat-radio-button class="example-radio-button" value="1"
        >single</mat-radio-button
      >
      <mat-radio-button class="example-radio-button" value="2"
        >multiple</mat-radio-button
      >
    </mat-radio-group>
  </div>
  <div [ngSwitch]="classNumber">
    <div *ngSwitchCase="1" class="class-container">
      <div
        *ngFor="let floor of classAreas; let floorIndex = index"
        class="deck-container"
      >
        <div
          *ngFor="let area of classAreas[floorIndex]; let i = index"
          class="margin-top-bottom"
        >
          <h3>Deck {{ floorIndex + 1 }}</h3>
          <mat-radio-group
            aria-labelledby="example-radio-group-label"
            class="example-radio-group"
            [ngModel]="area.class"
            (ngModelChange)="area.class = $event; resetParentValue()"
          >
            <mat-radio-button
              class="example-radio-button"
              *ngFor="let class of serviceClasses"
              [value]="class.id"
            >
              {{ class.name }}
            </mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
    </div>

    <div *ngSwitchCase="2" class="class-container">
      <div
        *ngFor="let floor of classAreas; let floorIndex = index"
        class="deck-container"
      >
        <h3>Deck {{ floorIndex + 1 }}</h3>
        <div
          *ngFor="let area of classAreas[floorIndex]; let i = index"
          class="margin-top-bottom"
        >
          <div>
            <mat-form-field appearance="outline" class="margin-left-right">
              <mat-label>Start of area</mat-label>
              <input
                matInput
                type="number"
                autoComplete="off"
                [ngModel]="i > 0 ? classAreas[floorIndex][i - 1].endpoint : 0"
                disabled
              />
            </mat-form-field>
            <mat-form-field appearance="outline" class="margin-left-right">
              <mat-label>End of area</mat-label>
              <input
                matInput
                type="number"
                autoComplete="off"
                step="1"
                [min]="i > 0 ? classAreas[floorIndex][i - 1].endpoint + 1 : 0"
                [max]="maxValue"
                [ngModel]="area.endpoint"
                (ngModelChange)="area.endpoint = $event; resetParentValue()"
              />
            </mat-form-field>
            <button
              mat-raised-button
              class="margin-left-right width-200"
              (click)="addClassCategory(floorIndex)"
              [disabled]="getAddButtonDisabledState(floorIndex, i)"
            >
              Add area
            </button>
            <button
              mat-raised-button
              class="margin-left-right width-200"
              *ngIf="i > 0"
              (click)="removeClassCategory(floorIndex)"
              [disabled]="getremoveButtonDisabledState(floorIndex, i)"
            >
              Remove area
            </button>
          </div>
          <mat-radio-group
            aria-labelledby="example-radio-group-label"
            class="example-radio-group"
            [ngModel]="area.class"
            (ngModelChange)="area.class = $event; resetParentValue()"
          >
            <mat-radio-button
              class="example-radio-button"
              *ngFor="let class of serviceClasses"
              [value]="class.id"
              name="classCategory"
              [checked]="class.id === area.value"
            >
              {{ class.name }}
            </mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
    </div>
    <div>
      <button
        mat-raised-button
        class="width-200"
        (click)="save()"
        [disabled]="getSaveButtonDisabledState()"
      >
        {{ wagonClass.buttonSaveChanges }}
      </button>
    </div>
  </div>
</div>
